<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Attendance<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadAttendance(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
            <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Academy first to view available Batches.</li>
              <li>Please select a Batch first to view available usernames.</li>
            </ul>
          </div>
            <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                  (onChange)="getBatchList($event)" placeholder="Select Academy" optionLabel="name"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="academyId"></p-dropdown>
                </li>
                <li>
                <p-dropdown inputId="totalCoaches" [options]="yearlist" [filter]="true"
                  (onChange)="loadAttendance(lastTableLazyLoadEvent)" placeholder="Select Year" optionLabel="label"
                  optionValue="value" appendTo="body" [showClear]="true" [(ngModel)]="year"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="batchList" [filter]="true"
                  (onChange)="getBatchPlayer($event)" placeholder="Select Batch" optionLabel="name"
                  appendTo="body" [showClear]="true" [(ngModel)]="batch" (onClear)="onClearBatchSelection($event)"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="months" [filter]="true"
                  (onChange)="loadAttendance(lastTableLazyLoadEvent)" placeholder="Select Month" optionLabel="label"
                  optionValue="value" appendTo="body" [showClear]="true" [(ngModel)]="month"></p-dropdown>
                </li> 
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="batchPlayers" [filter]="true"
                  (onChange)="loadAttendance(lastTableLazyLoadEvent)" placeholder="Select username" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="username"></p-dropdown>
                </li> 
              </ul>
            </div>
          </div> 
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="attendanceReportsData" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadAttendance($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="academyName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="created_at" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="created_at"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="fullName" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Name <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="SessionsTD" pSortableColumn="transferAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Total Sessions <p-sortIcon
                        field="transferAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="totalCreditedAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Present <p-sortIcon
                        field="totalCreditedAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="AbsentTD" pSortableColumn="bankName show-col"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Absent <p-sortIcon field="bankName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col">
                    <div class="p-d-flex p-jc-between p-ai-center"> Attendance Percentage <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Last Attended Date <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th [ngSwitch]="academyName" pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]=" dt.filters['academyName'] ? dt.filters['academyName'].value : ''" /> -->
                  </th>

                  <th [ngSwitch]="userName" class="userNameTD p-element   text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="created_at" class="userNameTD">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="transferAmount" class="SessionsTD p-element text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains') "
                      [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="totalCreditedAmount" class="transferCreditTD p-element   text-nowrap"
                    style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'totalCreditedAmount', 'contains') "
                      [value]=" dt.filters['totalCreditedAmount'] ? dt.filters['totalCreditedAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="bankName " class="AbsentTD show-col" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'bankName', 'contains')"
                      [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-attendance>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{attendance?.mobileNumber}}" tooltipPosition="bottom">
                      {{attendance?.mobileNumber}}
                    </div>
                  </td>
                  <td class="userNameTD">
                    {{ attendance?.username }}
                  </td>
                  <td class="userNameTD">
                    {{ attendance?.academyName }}
                  </td>
                  <td class="SessionsTD">
                    {{ attendance?.totalSessions }}
                  </td>
                  <td class="transferCreditTD ">
                    {{ attendance?.present }}
                  </td>
                  <td class="AbsentTD">
                    {{ attendance?.absent }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ attendance?.attendancePercentage }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ attendance?.lastAttendedDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                    
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Attendance list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
